module.exports = __webpack_public_path__ + "img/Invasion-PDAC_GSE205354.ab524b33.png";